import React, { useCallback } from "react";
import cn from "classnames";
import T from "prop-types";

import { PlaceholderWhen } from "2g-placeholder";

import TextComponent from "b2b/components/text-component";

import useMessages from "./i18n/useMessages";
import ZadostiGroupsPocet from "./ZadostiGroupsPocet";

function ZadostiGroupsAll({ sum, loading = false, onChange, showAll }) {
  const messages = useMessages();
  const onClickCallback = useCallback(() => {
    onChange();
  }, []);
  if (showAll === false) return null;
  const isActive = Boolean(sum) && loading === false;
  return (
    <div
      className={cn("b2b-ZadostiGroups-all", {
        "is-active": isActive,
        "is-disabled": !isActive
      })}
      onClick={isActive ? onClickCallback : undefined}
    >
      <TextComponent loading={loading}>{messages.all()}</TextComponent>
      <PlaceholderWhen test={isActive} placeholder={null}>
        <ZadostiGroupsPocet pocet={sum} />
      </PlaceholderWhen>
    </div>
  );
}

ZadostiGroupsAll.propTypes = {
  sum: T.number,
  loading: T.bool,
  onChange: T.func,
  showAll: T.bool
};

export default React.memo(ZadostiGroupsAll);
